// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDTeYjLYY-ZATk69MpUumefK6hGy8pTTbk",
  authDomain: "atharava-vidyalaya.firebaseapp.com",
  projectId: "atharava-vidyalaya",
  storageBucket: "atharava-vidyalaya.appspot.com",
  messagingSenderId: "310277625111",
  appId: "1:310277625111:web:e04c85e37776f5f913d352",
  measurementId: "G-R6TC092HY3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
